module.exports = __webpack_public_path__ + "img/ziben1.64714b9b.png";